import { Module } from 'vuex'
import { TechpacksState, state } from './techpacks.model'
import { actions } from './techpacks.actions'
import { mutations } from './techpacks.mutations'
import { getters } from './techpacks.getters'

export const techpacksModule: Module<TechpacksState, unknown> = {
  state,
  actions,
  mutations,
  getters
}
